import { useState } from 'react';

const VDK_LEGEND = [
  {
    pos: 1,
    field: 'Cinsiyet',
    color: 'bg-cyan-100 text-cyan-700 border-cyan-200',
    dotColor: 'bg-cyan-400',
    items: [
      { code: 'k', desc: 'Kadın' },
      { code: 'e', desc: 'Erkek' },
    ],
  },
  {
    pos: 2,
    field: 'Yaş Grubu',
    color: 'bg-cyan-100 text-cyan-700 border-cyan-200',
    dotColor: 'bg-cyan-400',
    items: [
      { code: '1', desc: '18–35 yaş' },
      { code: '2', desc: '36–50 yaş' },
      { code: '3', desc: '51–65 yaş' },
      { code: '4', desc: '66+ yaş' },
    ],
  },
  {
    pos: 3,
    field: 'Şeker (DM)',
    color: 'bg-cyan-100 text-cyan-700 border-cyan-200',
    dotColor: 'bg-cyan-400',
    items: [
      { code: '0', desc: 'Yok' },
      { code: '1', desc: 'Kontrollü diyabet' },
      { code: '2', desc: 'Kontrolsüz diyabet' },
    ],
  },
  {
    pos: 4,
    field: 'Sigara',
    color: 'bg-cyan-100 text-cyan-700 border-cyan-200',
    dotColor: 'bg-cyan-400',
    items: [
      { code: '0', desc: 'Yok' },
      { code: '1', desc: 'Az / orta kullanım' },
      { code: '2', desc: 'Yoğun kullanım' },
    ],
  },
  {
    pos: 5,
    field: 'Kemik Kalitesi',
    color: 'bg-red-100 text-red-700 border-red-200',
    dotColor: 'bg-red-500',
    items: [
      { code: '1', desc: 'Tip 1 — Çok yoğun / kortikal' },
      { code: '2', desc: 'Tip 2 — İyi kalite' },
      { code: '3', desc: 'Tip 3 — Az yoğun / süngerimsi' },
    ],
  },
  {
    pos: 6,
    field: 'Soket',
    color: 'bg-red-100 text-red-700 border-red-200',
    dotColor: 'bg-red-500',
    items: [
      { code: 'e', desc: 'Evet — Taze çekim soketi' },
      { code: 'h', desc: 'Hayır — İyileşmiş alan' },
    ],
  },
  {
    pos: 7,
    field: 'Greft',
    color: 'bg-red-100 text-red-700 border-red-200',
    dotColor: 'bg-red-500',
    items: [
      { code: 'e', desc: 'Evet — Greft uygulandı' },
      { code: 'h', desc: 'Hayır — Greft yok' },
    ],
  },
  {
    pos: 8,
    field: 'Hacim',
    color: 'bg-red-100 text-red-700 border-red-200',
    dotColor: 'bg-red-500',
    items: [
      { code: 'z', desc: 'Zayıf — Yetersiz kemik hacmi' },
      { code: 'y', desc: 'Yeterli — Normal kemik hacmi' },
    ],
  },
  {
    pos: 9,
    field: 'Healing',
    color: 'bg-red-100 text-red-700 border-red-200',
    dotColor: 'bg-red-500',
    items: [
      { code: 'e', desc: 'Evet — Healing abutment uygulandı' },
      { code: 'h', desc: 'Hayır — Healing yok' },
    ],
  },
];

type Props = {
  variant?: 'icon' | 'badge';
};

export default function VDKLegendModal({ variant = 'icon' }: Props) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {variant === 'badge' ? (
        <button
          type="button"
          onClick={() => setOpen(true)}
          className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-gray-100 hover:bg-teal-50 text-gray-500 hover:text-teal-600 text-xs font-semibold transition-all cursor-pointer whitespace-nowrap border border-gray-200 hover:border-teal-200"
        >
          <i className="ri-book-2-line text-sm"></i>
          VDK Rehberi
        </button>
      ) : (
        <button
          type="button"
          onClick={() => setOpen(true)}
          title="VDK Kod Rehberi"
          className="w-7 h-7 flex items-center justify-center rounded-lg bg-gray-100 hover:bg-teal-50 text-gray-400 hover:text-teal-600 transition-all cursor-pointer border border-gray-200 hover:border-teal-200"
        >
          <i className="ri-question-line text-base"></i>
        </button>
      )}

      {open && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          onClick={() => setOpen(false)}
        >
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/30 backdrop-blur-sm" />

          {/* Panel */}
          <div
            className="relative bg-white rounded-2xl w-full max-w-lg max-h-[90vh] overflow-hidden flex flex-col"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header */}
            <div className="bg-gradient-to-r from-teal-500 to-cyan-600 px-6 py-4 flex items-center justify-between flex-shrink-0">
              <div>
                <h2 className="text-white font-bold text-base tracking-wide">Vaka Durum Kodu (VDK)</h2>
                <p className="text-teal-100 text-xs mt-0.5">Kod yapısı ve değer açıklamaları</p>
              </div>
              <button
                type="button"
                onClick={() => setOpen(false)}
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-white/20 hover:bg-white/30 text-white transition-all cursor-pointer"
              >
                <i className="ri-close-line text-lg"></i>
              </button>
            </div>

            {/* Code preview bar */}
            <div className="px-6 py-3 bg-gray-50 border-b border-gray-100 flex-shrink-0">
              <p className="text-xs text-gray-400 uppercase tracking-widest mb-1.5 font-semibold">Kod formatı (9 karakter)</p>
              <div className="flex items-center gap-0.5">
                {VDK_LEGEND.map((item) => (
                  <div key={item.pos} className="flex flex-col items-center gap-1">
                    <div className={`w-10 h-9 rounded-md border font-mono font-bold text-sm flex items-center justify-center ${item.color}`}>
                      {item.pos}
                    </div>
                    <span className="text-[9px] text-gray-400 font-medium">{item.pos}</span>
                  </div>
                ))}
              </div>
              <div className="flex gap-3 mt-2">
                <span className="text-xs text-gray-400 flex items-center gap-1">
                  <span className="w-2 h-2 bg-cyan-400 rounded-sm inline-block"></span>
                  Pozisyon 1–4: Hasta bilgisi
                </span>
                <span className="text-xs text-gray-400 flex items-center gap-1">
                  <span className="w-2 h-2 bg-red-500 rounded-sm inline-block"></span>
                  Pozisyon 5–9: Diş bilgisi
                </span>
              </div>
            </div>

            {/* Legend rows — scrollable */}
            <div className="overflow-y-auto flex-1 px-6 py-4 space-y-3">
              {VDK_LEGEND.map((item) => (
                <div key={item.pos} className="flex gap-3 items-start">
                  {/* Position badge */}
                  <div className={`w-7 h-7 rounded-lg border flex items-center justify-center font-bold text-xs flex-shrink-0 mt-0.5 ${item.color}`}>
                    {item.pos}
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center gap-1.5 mb-1.5">
                      <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${item.dotColor}`}></span>
                      <span className="text-xs font-bold text-gray-600 uppercase tracking-wide">{item.field}</span>
                    </div>
                    <div className="flex flex-wrap gap-1.5">
                      {item.items.map((v) => (
                        <span
                          key={v.code}
                          className="inline-flex items-center gap-1.5 px-2 py-1 rounded-lg bg-gray-50 border border-gray-100 text-xs text-gray-600"
                        >
                          <span className={`font-mono font-bold text-sm ${item.dotColor === 'bg-cyan-400' ? 'text-cyan-600' : 'text-red-600'}`}>
                            {v.code.toUpperCase()}
                          </span>
                          <span className="text-gray-400">—</span>
                          {v.desc}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Footer */}
            <div className="px-6 py-3 bg-gray-50 border-t border-gray-100 flex-shrink-0">
              <p className="text-xs text-gray-400 text-center">
                Örnek: <span className="font-mono font-bold text-gray-600">k12e2ehye</span> → Kadın · 36-50 yaş · Kontrollü DM · Yoğun sigara · Tip 2 kemik · Taze soket · Greft yok · Yeterli hacim · Healing var
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
